import { StyleData } from '../models/Theme';
import { createCtx } from './createCtx';

export type ThemeContextType = {
    theme: StyleData;
    setTheme: (theme: StyleData) => void;
};

export const [useTheme, CtxProvider] = createCtx<ThemeContextType>();
